import React, { ReactElement } from "react";
import styles from "./bulletList.module.scss";
import { type IContent } from "@kunduz/data-access-cms-api";
import { Check } from "@untitled-ui/icons-react";
import { blue } from "../../../theme";

export const PlanDetailBulletList = (props: Props): ReactElement => {
  const half = Math.ceil((props.data.bullets?.length || 0) / 2);
  const firstHalfItems = props.data.bullets?.slice(0, half);
  const secondHalfItems = props.data.bullets?.slice(
    half,
    props.data.bullets.length,
  );

  return (
    <>
      {props.data.title && <p className={styles.title}>{props.data.title}</p>}

      <div className={styles.itemWrapper}>
        <div className={styles.column}>
          {firstHalfItems?.map((b, i) => (
            <div className={styles.listItem} key={`bullet_${b.order}_${i}`}>
              <Check color={blue[600]} width={16} height={16} />
              <div dangerouslySetInnerHTML={{ __html: b.text }}></div>
            </div>
          ))}
        </div>
        <div className={styles.column}>
          {secondHalfItems?.map((b, i) => (
            <div className={styles.listItem} key={`bullet_${b.order}_${i}`}>
              <Check color={blue[600]} width={16} height={16} />
              <div dangerouslySetInnerHTML={{ __html: b.text }}></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

interface Props {
  data: IContent.PlanDetailV2AccordionData["items"][0]["items"][0]["data"];
}
